import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {GalleryModalHolderStyled} from "./OfferGalleryModalContent";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

export const ConstructionGalleryPlaceholder = () => {
    return (
        <GalleryModalHolderStyled css={holder}>
            <div css={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    css={imageStyle}
                />
                <Text variant="headline_4" as="p" color="white" align="center" mb={3}>
                    Przepraszamy, nie możemy wyświetlić zdjęć z budowy dla tej oferty.
                </Text>
            </div>
        </GalleryModalHolderStyled>
    );
};

const holder = css`
    ${p(2)}
    justify-content: center;
    align-content: center;

    @media (min-width: ${getThemeBreakpoint().md}) {
        height: 100%;
    }
`;

const innerStyle = css`
    display: flex;
    flex-direction: column;

    justify-content: center;
    max-width: 431px;
`;

const imageStyle = css`
    ${mb(4)};
    display: flex;
    justify-content: center;
`;
import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {GalleryModalHolderStyled} from "./OfferGalleryModalContent";

import missingConstructionImagesSVG from "../../detail/img/missing_construction_images.svg";

export const ConstructionGalleryPlaceholder = () => {
    return (
        <GalleryModalHolderStyled css={holder}>
            <div css={innerStyle}>
                <Image
                    src={missingConstructionImagesSVG}
                    width="260px"
                    height="244px"
                    alt="kartka zawierająca prosty schemat bloku mieszkalnego"
                    css={imageStyle}
                />
                <Text variant="headline_4" as="p" color="white" align="center" mb={3}>
                    Przepraszamy, nie możemy wyświetlić zdjęć z budowy dla tej oferty.
                </Text>
            </div>
        </GalleryModalHolderStyled>
    );
};

const holder = css`
    ${p(2)}
    justify-content: center;
    align-content: center;

    @media (min-width: ${getThemeBreakpoint().md}) {
        height: 100%;
    }
`;

const innerStyle = css`
    display: flex;
    flex-direction: column;

    justify-content: center;
    max-width: 431px;
`;

const imageStyle = css`
    ${mb(4)};
    display: flex;
    justify-content: center;
`;
